export default function isNullish(val: any) {
  return [null, undefined, false].includes(val)
}
